import type { TransferDirection } from './types';
import type { TKey } from '../i18n/dictionary';

/** Prototyp, objekt TRANSFERS. */
export interface TransferDef {
  direction: TransferDirection;
  /** Klíč překladu pro text banneru (ODESLAT DO ČR / SR). */
  bannerKey: TKey;
  /** Klíč překladu pro hodnotu zapisovanou do objednávky (Převezeno do ČR / SR). */
  valueKey: TKey;
  /** Klíč překladu pro řádek ve verdiktu („Zásilku nutno převézt do …“). */
  noteKey: TKey;
  bg: string;
  /** Volitelné podbarvení celé stránky – spec 4b to NEDOPORUČUJE zapínat. */
  tint: string;
  barTint: string;
  /** Odznak NALOŽIT DNES – jen u SK a jen u zelené vrstvy. */
  loadToday: boolean;
}

export const TRANSFERS: Record<TransferDirection, TransferDef> = {
  CZ: {
    direction: 'CZ',
    bannerKey: 'trCZ',
    valueKey: 'trValCZ',
    noteKey: 'trNoteCZ',
    bg: '#B54708',
    tint: '#FEF3D2',
    barTint: '#FEF9E7',
    loadToday: false,
  },
  SK: {
    direction: 'SK',
    bannerKey: 'trSK',
    valueKey: 'trValSK',
    noteKey: 'trNoteSK',
    bg: '#1849A9',
    tint: '#E0EBFB',
    barTint: '#EFF5FE',
    loadToday: true,
  },
};
